// ========================================
// 🎯 ACTION TYPES
// ========================================

export const GET_MODULE_REQUEST = 'GET_MODULE_REQUEST';
export const GET_MODULE_SUCCESS = 'GET_MODULE_SUCCESS';
export const GET_MODULE_FAIL = 'GET_MODULE_FAIL';

export const GET_ALL_MODULES_REQUEST = 'GET_ALL_MODULES_REQUEST';
export const GET_ALL_MODULES_SUCCESS = 'GET_ALL_MODULES_SUCCESS';
export const GET_ALL_MODULES_FAIL = 'GET_ALL_MODULES_FAIL';

export const GET_MODULES_BY_STATUS_REQUEST = 'GET_MODULES_BY_STATUS_REQUEST';
export const GET_MODULES_BY_STATUS_SUCCESS = 'GET_MODULES_BY_STATUS_SUCCESS';
export const GET_MODULES_BY_STATUS_FAIL = 'GET_MODULES_BY_STATUS_FAIL';

export const GET_ROOT_MODULES_REQUEST = 'GET_ROOT_MODULES_REQUEST';
export const GET_ROOT_MODULES_SUCCESS = 'GET_ROOT_MODULES_SUCCESS';
export const GET_ROOT_MODULES_FAIL = 'GET_ROOT_MODULES_FAIL';

export const GET_CHILD_MODULES_REQUEST = 'GET_CHILD_MODULES_REQUEST';
export const GET_CHILD_MODULES_SUCCESS = 'GET_CHILD_MODULES_SUCCESS';
export const GET_CHILD_MODULES_FAIL = 'GET_CHILD_MODULES_FAIL';

export const CREATE_MODULE_REQUEST = 'CREATE_MODULE_REQUEST';
export const CREATE_MODULE_SUCCESS = 'CREATE_MODULE_SUCCESS';
export const CREATE_MODULE_FAIL = 'CREATE_MODULE_FAIL';

export const UPDATE_MODULE_REQUEST = 'UPDATE_MODULE_REQUEST';
export const UPDATE_MODULE_SUCCESS = 'UPDATE_MODULE_SUCCESS';
export const UPDATE_MODULE_FAIL = 'UPDATE_MODULE_FAIL';

export const DELETE_MODULE_REQUEST = 'DELETE_MODULE_REQUEST';
export const DELETE_MODULE_SUCCESS = 'DELETE_MODULE_SUCCESS';
export const DELETE_MODULE_FAIL = 'DELETE_MODULE_FAIL';

export const SET_MODULE_LOADING = 'SET_MODULE_LOADING';

// ========================================
// 🎬 ACTION CREATORS
// ========================================

export const setModuleLoading = (loading) => ({
    type: SET_MODULE_LOADING,
    payload: loading,
});

// --- GET BY ID ---
export const getModuleRequest = (moduleId) => ({
    type: GET_MODULE_REQUEST,
    payload: { moduleId },
});
export const getModuleSuccess = (module) => ({
    type: GET_MODULE_SUCCESS,
    payload: module,
});
export const getModuleFail = (error) => ({
    type: GET_MODULE_FAIL,
    error,
});

// --- GET ALL ---
export const getAllModulesRequest = () => ({ type: GET_ALL_MODULES_REQUEST });
export const getAllModulesSuccess = (modules) => ({
    type: GET_ALL_MODULES_SUCCESS,
    payload: modules,
});
export const getAllModulesFail = (error) => ({
    type: GET_ALL_MODULES_FAIL,
    error,
});

// --- GET BY STATUS ---
export const getModulesByStatusRequest = (status) => ({
    type: GET_MODULES_BY_STATUS_REQUEST,
    payload: { status },
});
export const getModulesByStatusSuccess = (modules) => ({
    type: GET_MODULES_BY_STATUS_SUCCESS,
    payload: modules,
});
export const getModulesByStatusFail = (error) => ({
    type: GET_MODULES_BY_STATUS_FAIL,
    error,
});

// --- GET ROOT ---
export const getRootModulesRequest = () => ({ type: GET_ROOT_MODULES_REQUEST });
export const getRootModulesSuccess = (modules) => ({
    type: GET_ROOT_MODULES_SUCCESS,
    payload: modules,
});
export const getRootModulesFail = (error) => ({
    type: GET_ROOT_MODULES_FAIL,
    error,
});

// --- GET CHILDREN ---
export const getChildModulesRequest = (parentId) => ({
    type: GET_CHILD_MODULES_REQUEST,
    payload: { parentId },
});
export const getChildModulesSuccess = (modules) => ({
    type: GET_CHILD_MODULES_SUCCESS,
    payload: modules,
});
export const getChildModulesFail = (error) => ({
    type: GET_CHILD_MODULES_FAIL,
    error,
});

// --- CREATE ---
export const createModuleRequest = (moduleData) => ({
    type: CREATE_MODULE_REQUEST,
    payload: moduleData,
});
export const createModuleSuccess = (module) => ({
    type: CREATE_MODULE_SUCCESS,
    payload: module,
});
export const createModuleFail = (error) => ({
    type: CREATE_MODULE_FAIL,
    error,
});

// --- UPDATE ---
export const updateModuleRequest = (moduleId, moduleData) => ({
    type: UPDATE_MODULE_REQUEST,
    payload: { moduleId, moduleData },
});
export const updateModuleSuccess = (module) => ({
    type: UPDATE_MODULE_SUCCESS,
    payload: module,
});
export const updateModuleFail = (error) => ({
    type: UPDATE_MODULE_FAIL,
    error,
});

// --- DELETE ---
export const deleteModuleRequest = (moduleId) => ({
    type: DELETE_MODULE_REQUEST,
    payload: { moduleId },
});
export const deleteModuleSuccess = (moduleId) => ({
    type: DELETE_MODULE_SUCCESS,
    payload: { moduleId },
});
export const deleteModuleFail = (error) => ({
    type: DELETE_MODULE_FAIL,
    error,
});